import React from 'react';
import { motion } from 'framer-motion';
import { WaveDivider } from './ui/WaveDivider';
export function MechanismSection() {
  return <section className="relative bg-deep-teal text-cream py-24 mt-0" data-id="element-109">
      <WaveDivider position="top" fill="#ffffff" className="absolute top-0 left-0 w-full -mt-[1px]" data-id="element-110" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-8" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-112">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-3" data-id="element-113">
            The Unique Mechanism
          </h2>
          <h3 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-114">
            Introducing the{' '}
            <span className="text-gold italic" data-id="element-115">Hormone Cooling Protocol</span>
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-116">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-cream/90 leading-relaxed" data-id="element-117">
            <p data-id="element-118">
              Instead of fighting your body with hunger and exhaustion, we use a{' '}
              <strong data-id="element-119">7-minute neurobiological sequence</strong> before bed.
            </p>
            <p data-id="element-120">
              This method lowers your core temperature and activates the Vagus
              Nerve, sending an immediate signal to your brain:{' '}
              <span className="text-gold font-bold" data-id="element-121">
                "It is safe to burn energy."
              </span>
            </p>
            <p data-id="element-122">
              This isn't a diet; it's a reset of your hormonal operating system
              while you rest deeply.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-123">
            <div className="absolute inset-0 bg-gold blur-3xl opacity-20 rounded-full" data-id="element-124"></div>
            <div className="relative bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm" data-id="element-125">
              <div className="flex items-center gap-4 mb-6" data-id="element-126">
                <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center text-gold font-bold text-xl" data-id="element-127">
                  7
                </div>
                <h4 className="text-xl font-bold text-white" data-id="element-128">
                  Minutes a Night
                </h4>
              </div>
              <ul className="space-y-4" data-id="element-129">
                <li className="flex items-center gap-3" data-id="element-130">
                  <div className="w-2 h-2 rounded-full bg-gold" data-id="element-131"></div>
                  <span data-id="element-132">Lowers core temperature</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-133">
                  <div className="w-2 h-2 rounded-full bg-gold" data-id="element-134"></div>
                  <span data-id="element-135">Activates Vagus Nerve</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-136">
                  <div className="w-2 h-2 rounded-full bg-gold" data-id="element-137"></div>
                  <span data-id="element-138">Signals safety to burn fat</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>

      <WaveDivider position="bottom" fill="#FDF8F0" className="absolute bottom-0 left-0 w-full -mb-[1px]" data-id="element-139" />
    </section>;
}